import { combineReducers } from 'redux-immutable'

import account from 'app/modules/account/reducer'
import apiKey from 'app/modules/apiKey/reducer'
import assistantSettings from 'app/modules/assistantSettings/reducer'
import { bannedIPs, bannedIPStatus } from 'app/modules/ban/reducer'
import campaigns from 'app/modules/campaigns'
import cards from 'app/modules/cards'
import classification from 'app/modules/classification'
import composer from 'app/modules/composer'
import conversations from 'app/modules/conversation'
import csv from 'app/modules/csv'
import embed from 'app/modules/embed'
import endUser from 'app/modules/endUser'
import geolocation from 'app/modules/geolocation'
import inbox from 'app/modules/inbox'
import { integrations, wordpressIntegrationDomain } from 'app/modules/integrations/reducers'
import googleAnalytics from 'app/modules/googleAnalytics'
import hubspot from 'app/modules/hubspot'
import meetings from 'app/modules/meetings'
import messages from 'app/modules/message'
import overview from 'app/modules/org/overview'
import { org, orgUI } from 'app/modules/org/reducers'
import { teams } from 'app/modules/teams/reducer'
import participants from 'app/modules/participants'
import playbooks from 'app/modules/playbook'
import { profile, profileUI } from 'app/modules/profile/reducers'
import presence from 'app/modules/presence'
import reveal from 'app/modules/reveal'
import router from 'app/modules/router'
import rules from 'app/modules/rules'
import segment from 'app/modules/segment'
import sfdc from 'app/modules/sfdc'
import marketo from 'app/modules/marketo'
import eloqua from 'app/modules/eloqua'
import pardot from 'app/modules/pardot'
import socket from 'app/modules/socket'
import tags from 'app/modules/tags'
import targeting from 'app/modules/targeting'
import typing from 'app/modules/typing'
import unread from 'app/modules/unread'
import userProperties from 'app/modules/user/properties'
import { currentUser } from 'app/modules/user/reducers'
import enrichment from 'app/modules/enrichment'
import gates from 'app/modules/gates'
import externalApp from 'app/modules/externalApp'
import conversationBulkUpdate from 'app/modules/conversation/bulkUpdate'
import experiment from 'app/modules/experiment'

export const makeRootReducer = asyncReducers => {
  return combineReducers({
    account,
    apiKey,
    assistantSettings,
    bannedIPs,
    bannedIPStatus,
    campaigns,
    cards,
    classification,
    composer,
    conversations,
    csv,
    currentUser,
    embed,
    endUser,
    enrichment,
    gates,
    geolocation,
    hubspot,
    googleAnalytics,
    inbox,
    integrations,
    wordpressIntegrationDomain,
    marketo,
    eloqua,
    meetings,
    messages,
    org,
    teams,
    orgUI,
    overview,
    participants,
    playbooks,
    presence,
    profile,
    profileUI,
    reveal,
    router,
    rules,
    segment,
    sfdc,
    socket,
    tags,
    targeting,
    typing,
    unread,
    userProperties,
    externalApp,
    conversationBulkUpdate,
    experiment,
    pardot,
    ...asyncReducers,
  })
}

export const injectReducer = (store, { key, reducer }) => {
  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer



// WEBPACK FOOTER //
// ./src/scripts/store/reducers/index.js